const InvoiceDataValidation = (invoiceData) => {
    let isValid = true;
    let Error = {
        dateDue: null,
        customer: null,
        phone: null,
        items: [],
    };

    // if (!invoiceData?.dateDue) {
    //     Error.dateDue = "Please select valid date!";
    //     isValid = false;
    // }

    if (!invoiceData?.customer?.trim()) {
        Error.customer = "Please enter a valid business name!";
        isValid = false;
    }


    // Validate items
    invoiceData?.items?.forEach((item, index) => {
        let itemErrors = { name: null, quantity: null, price: null };

        if (!item?.name?.trim()) {
            itemErrors.name = "Please enter valid item name!";
            isValid = false;
        }

        if (!item?.quantity || item?.quantity <= 0 || isNaN(item?.quantity)) {
            itemErrors.quantity = "Please enter valid quantity!";
            isValid = false;
        }

        if (!item?.price || item?.price <= 0 || isNaN(item?.price)) {
            itemErrors.price = "Please enter valid Price!";
            isValid = false;
        }

        Error.items[index] = itemErrors;
    });

    return { isValid: isValid, errors: Error };
};

export default InvoiceDataValidation;
